import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { UserContext } from '../context/UserProvider';
import '../components/componentsCSS/Login.css';
import { Button, Form, FormGroup } from 'reactstrap';


import BlueButton from './BlueButton';
import InputForm from './InputForm';


const Login = (props) => {

    const { handleGoogle } = useContext(UserContext);

    const loginGoogle = (e) => {
        e.preventDefault();
        handleGoogle();
        return props.history.push('/dashboard');
    };

    return (
        <div>


            <div className='d-flex justify-content-center mt-5'>
                <img src='https://github.com/BrendaCarranco/laaps/blob/master/img/logoNombre.png?raw=true' alt='logo' />
            </div>
            <Form className="login-form">

                <div className='blue-button mt-3 '>
                    <Button size="lg" block className='button-2' onClick={loginGoogle} >Inicia sesión con Google</Button>
                </div>

                <div className='d-flex justify-content-center'>
                    <p>O</p>
                </div>
                <FormGroup>
                    <InputForm placeholder={'Correo electrónico'} type='email' />

                </FormGroup>
                <FormGroup>
                    <InputForm placeholder={'Contraseña'} type='password' />
                    <p>¿Olvidaste tu contraseña?</p>
                </FormGroup>

            </Form>
            <div className='container'>
                <BlueButton label={'Entrar'} />
            </div>

            <div className="text-center pt-3" >
                <a href='/info'>¿Eres nuevo en Laaps? Registrate</a>
            </div>

        </div>
    );
};

export default withRouter(Login);